
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Card from '../../ui/Card';
import { Form } from 'react-final-form';
import { useToken, WalletService } from '../../../services';

import './styles.css';
import Input from '../../ui/Input';
import Alert from '../../ui/Alert';

function Creation({ onUpdateTable }) {
  const { getToken } = useToken();
  const intervalRef = useRef(null);
  const refSetState = useRef(true);
  const [states, setStates] = useState({
    msg: '',
    error: false,
    loading: false,
    enableMsg: false,
  });

  const handleValidation = useCallback(
    async (formData, submit = false) => {
      if (!!formData['amount'] || submit) {
        const value = Number(String(formData['amount']).replace(/\D/g, ''));
  
        if (value <= 0 || isNaN(value)) {
          return {
            amount: "Valor inválido."
          }
        }
      }
    },
    [],
  );

  const handleSubmitForm = useCallback(
    async (formData, form) => {
      const validations = await handleValidation(formData, true);
      if (validations) return validations;

      let msg = '';
      let error = false;
      setStates(stt => ({...stt, loading: true, enableMsg: false }));

      try {
        const token = await getToken();
        const data = {
          token,
          amount: Number(String(formData['amount']).replace(/\D/g, '')),
        }

        const result = await WalletService.postDeposit(data);

        if (result.error) {
          throw new Error(result.msgError);
        }

        msg = 'Aporte adicionado com sucesso.';
      } catch (err) {
        error = true;
        if (err instanceof Error) {
          msg = err.message.slice(0, 80);
        }
      } finally {
        if (refSetState.current) {
          setStates({ loading: false, enableMsg: true, msg, error });

          if (!error) {
            setTimeout(form.reset);
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(() => {
              setStates(stt => ({...stt, enableMsg: false }));
            }, 4000);

            onUpdateTable();
          }
        }
      }
    },
    [handleValidation],
  );

  useEffect(() => {
    refSetState.current = true;

    return () => {
      refSetState.current = false;
      clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  return (
    <Card title="Adicionar aporte" disabled={states.loading}>
      {states.enableMsg && (
        <Alert
          msg={states.msg} 
          error={states.error}
          onClose={() => {
            setStates(stt => ({...stt, enableMsg: false }));
          }}
        />
      )}
      <Form
        onSubmit={handleSubmitForm}
        validate={handleValidation}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className="wa__form">
            <Input
              onMask={(val) => {
                const number = String(val).replace(/\D/g, '');
                return number === '' ? '' : `R$ ${number}`;
              }}
              type="text"
              label="Valor:"
              name="amount"
              placeholder="Digite o valor do novo aporte"
            />
            <button 
              type="submit" 
              className="z-button"
              disabled={states.loading}>
              {states.loading ? 'Carregando...' : 'Adicionar'}
            </button>
          </form>
        )}
      />
    </Card>
  );
}

export default Creation;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/functional/Creation/index.js